"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.toRegulatedInformationSlice = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var constants_1 = require("../constants");
var fields_1 = require("../fields");
var slice_1 = require("./slice");
var toRegulatedInformationSlice = function (data, logger) {
    var informations = data === null || data === void 0 ? void 0 : data.items.map(function (item) {
        var title = logger.required(fields_1.toText(item.title));
        var publicationType = constants_1.toPublication(item.publicationType, logger);
        var nbDocs = logger.required(fields_1.toNumber(item.nb_docs));
        var ctaText = logger.required(fields_1.toText(item.cta_text));
        if (!title && !publicationType && !ctaText && !(nbDocs > 0)) {
            return null;
        }
        return utils_1.compact({
            title: title,
            publicationType: publicationType,
            nbDocs: nbDocs,
            ctaText: ctaText
        });
    }).filter(Boolean);
    var other;
    var other_title = logger.required(fields_1.toText(data.primary.other_title));
    var other_ctaText = logger.required(fields_1.toText(data.primary.other_cta_text));
    var other_ctaLink = logger.required(fields_1.toLink(data.primary.other_cta_link, logger));
    if (other_title && other_ctaText && other_ctaLink) {
        other = utils_1.compact({
            title: other_title,
            ctaText: other_ctaText,
            ctaLink: other_ctaLink
        });
    }
    if (informations && informations.length) {
        return utils_1.compact(__assign(__assign({}, slice_1.toSlice(data, types_1.SliceType.RegulatedInformation)), { menu_title: fields_1.toText(data.primary.menu_title), menu_subtitle: fields_1.toText(data.primary.menu_subtitle), informations: informations,
            other: other }));
    }
    return undefined;
};
exports.toRegulatedInformationSlice = toRegulatedInformationSlice;
//# sourceMappingURL=regulated-information.js.map